const getNowUtcTsUnix = (): string => {
    const ts = new Date().getTime();

    return (ts / 1000).toString();
};

export default {
    getNowUtcTsUnix,
};
